import { useMemo } from 'react';
import { useApp } from '../context/AppContext';
import { archetypes } from '../data/archetypes';
import Oracle from '../components/Oracle';
import styles from './OraclePage.module.css';

export default function OraclePage() {
  const { state, dispatch } = useApp();

  const { primary, primaryKey } = useMemo(() => {
    const sorted = Object.entries(state.scores).sort((a, b) => b[1] - a[1]);
    const primaryKey = sorted[0] ? sorted[0][0] : 'jester';
    const primary = archetypes[primaryKey];
    return { primary, primaryKey };
  }, [state.scores]);

  const handleBack = () => {
    dispatch({ type: 'SET_PAGE', payload: 'result' });
  };

  return (
    <div className={styles.container}>
      <Oracle
        archetype={primaryKey}
        archetypeInfo={primary}
        onClose={handleBack}
        isFullPage={true}
      />
    </div>
  );
}
